// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3LmVE","real-checkbox":"hoUbY","realCheckbox":"hoUbY","icon":"K0_Fo","checked":"_2njZE"};